module.exports = __webpack_public_path__ + "static/media/NA.fe83aabb.png";